import React from 'react';

interface DeleteModalProps {
    chatTitle: string;
    onConfirm: () => void;
    onCancel: () => void;
}

const DeleteModal: React.FC<DeleteModalProps> = ({ chatTitle, onConfirm, onCancel }) => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
                <h2 className="text-lg font-semibold mb-4">Delete chat?</h2>
                <p className="text-sm text-gray-700 mb-6">
                    This will delete <span className="font-semibold">{chatTitle}</span> chat.
                </p>
                <div className="flex w-full gap-4">
                    <button
                        onClick={onCancel}
                        className="flex-1 button-1"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="flex-1 border border-gray-800 !text-gray-800 !bg-transparent button-1"
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteModal;
